module.exports = require("uglify-js");